import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, NgClass } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cv-autocomplete',
  standalone: true,
  imports: [
    NgClass,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    MatIconModule,
  ],
  templateUrl: './autocomplete.component.html',
  styleUrl: './autocomplete.component.css',
})
export class AutocompleteComponent {
  @ViewChild('inputAutocomplete', { static: false })
  inputAutocomplete!: ElementRef<HTMLInputElement>;
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() options!: any;
  @Input() myControl!: FormControl;
  @Input() loading = false;
  @Input() floatLabel = true;
  @Input() icon = false;
  @Input() isAirport = false;
  @Input() minValue = 4;
  @Input() errorMessage? = '';
  @Output() optionSelected = new EventEmitter<void>();
  isDescription = false;

  highlightMatch(option: string, filter: string): string {
    if (!filter) {
      return option;
    }
    const escapedFilter = filter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedFilter.toLowerCase()})`, 'gi');
    return option.replace(regex, '<span class="highlight">$1</span>');
  }
  displayFn(value: string): string {
    return value ?? '';
  }
  onOptionSelected() {
    this.optionSelected.emit();
  }
  clear() {
    this.myControl.setValue('');
    this.myControl.markAsUntouched();
    this.myControl.markAsPristine();
  }
  formatIata(value: string): string {
    const index = value.indexOf(' ');
    const iata = value.substring(0, index);
    const city = value.substring(index + 1);
    if (iata) {
      return `<strong>${iata}</strong> ${city}`;
    }
    return value;
  }
  get formattedSelectedOption(): string {
    const value = this.myControl.value;

    if (!value) {
      return `<span class="text-gray-400">${this.placeholder}</span>`;
    }
    if (this.isAirport) {
      return this.formatIata(value);
    }
    return value;
  }

  focusInput() {
    setTimeout(() => {
      this.inputAutocomplete?.nativeElement?.focus();
    }, 0);
  }
}
